export const ALERT = {
  error: "error",
  warning: "warning",
  info: "info",
  success: "success",
};
